import React, { Component } from "react";
import {Col, Dropdown} from "react-bootstrap";

/**
 * Shipping constants
 */
import METHOD from "../../../constants/shipping/MethodTypesNew";

class PickSlipDropdownMenuNew extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <Col sm={8} style={{display: "inline-block"}}>
            <Dropdown>
                <Dropdown.Toggle className={"all-shipment-button-toggle"} id="dropdown-basic">
                    Print Pick Slips
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips('ALL')}>
                        All Pick Slips
                    </Dropdown.Item>
                    <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips(METHOD.CLICKCOLLECT)}>
                        Print Click & Collect
                    </Dropdown.Item>
                    {/* <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips(METHOD.SAME_DAY)}>
                        US Same Day Delivery
                    </Dropdown.Item> */}
                    <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips('ALL', 'US')}>
                        US All Pick Slips
                    </Dropdown.Item>
                    {/* <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips(METHOD.SAME_DAY, 'perfect_stranger')}>
                        PS Same Day Delivery
                    </Dropdown.Item> */}
                    <Dropdown.Item className={"all-shipment-button-list"} onClick={() => this.props.generatePickSlips('ALL', 'PS')}>
                        PS All Pick Slips
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </Col>
    }
}

export default PickSlipDropdownMenuNew;
